import { APP_INITIALIZER, NgModule } from '@angular/core';
import {
  AuthModule,
  LogLevel,
  OidcConfigService,
} from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

export function computeAuthClientId(): string {
  if (environment.features.organizationAsAdmin) {
    if (environment.organizationAsAdmin != null) {
      if (
        window.location.host.match(
          environment.organizationAsAdmin.subDomainRegex
        ) != null
      ) {
        // The host matches the admin-as-manager domain, use the admin client id.
        return environment.organizationAsAdmin.authClientId;
      }
    } else {
      throw Error(
        'feature organizationAsAdmin enabled but no organizationAsAdmin configuration in current environment.*.ts!'
      );
    }
  }
  return environment.authClientId;
}

export function configureAuth(
  oidcConfigService: OidcConfigService
): () => Promise<any> {
  const authClientId = computeAuthClientId();
  // Remove the cached well-known endpoints to make sure the lib will
  // refresh them.
  localStorage.removeItem(`${authClientId}_authWellKnownEndPoints`);
  return () =>
    oidcConfigService.withConfig({
      stsServer: environment.stsServer,
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      clientId: authClientId,
      scope: 'openid profile offline_access', // 'openid profile offline_access ' + your scopes
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      renewTimeBeforeTokenExpiresInSeconds: 30,
      storage: localStorage,
      logLevel: LogLevel.Warn,
      forbiddenRoute: 'auth-fail',
      unauthorizedRoute: 'auth-fail',
      maxIdTokenIatOffsetAllowedInSeconds: 300, // To avoid issues with clients that have an earlier clock.
    });
}

@NgModule({
  imports: [AuthModule.forRoot()],
  exports: [AuthModule],
  providers: [
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    },
  ],
})
export class AuthConfigModule {}
